import { Entity, IEntity } from "./Entity";
import { IEntityCustomFields } from "./EntityCustomFields";
import { IUser } from "./User";
import { IApp03Workflow } from "./App03Workflow";
import { IApp03EpicEvidence } from "./App03EpicEvidence";
import { TaskPriority } from "../refData/WorkflowType";
import { IApp03EpicObserver } from "./App03EpicObserver";
import { App03EpicDep, IApp03EpicDep } from "./App03EpicDep";

export interface IApp03Epic extends IEntity, IEntityCustomFields {
    EpicRef?: string;
    Description?: string;
    WorkflowID?: number;
    EpicStatus?: string;
    EpicPriorityID?: number;
    StartDate?: Date;
    TargetEndDate?: Date;
    ActualEndDate?: Date;
    EpicOwnerID?: number;
    CreatedByID?: number;
    CreatedOn?: Date;
    ModifiedOn?: Date;
    FrameworkID?: number;
    CustomerID?: number;

    EpicOwner?: IUser;
    Workflow?: IApp03Workflow;
    App03EpicEvidences?: IApp03EpicEvidence[];
    App03EpicObservers?: IApp03EpicObserver[];

    Dependencies?: IApp03EpicDep[]; // Epics this one depends on (this epic parents)
    Dependents?: IApp03EpicDep[]; // Epics that depend on this one (this epic children)
}

export class App03Epic extends Entity implements IApp03Epic {
    public EpicRef = null;
    public Description = null;
    public WorkflowID = null;
    public EpicStatus = null;
    public EpicPriorityID = null;
    public StartDate = null;
    public TargetEndDate = null;
    public ActualEndDate = null;
    public EpicOwnerID = null;
    public CreatedByID = null;
    public CreatedOn = null;
    public ModifiedOn = null;
    public FrameworkID = null;
    public CustomerID = null;

    public EpicOwner = null;
    public Workflow = null;
    public App03EpicEvidences = [];

    public CustomFields = [];

    constructor() {
        super();
        this.EpicPriorityID = TaskPriority.Normal;
        const now = new Date();
        this.StartDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    }
}

export const App03EpicStatus = {
    NotStarted: "NotStarted",
    InProgress: "InProgress",
    Completed: "Completed",
    Canceled: "Canceled",
} as const;

export type App03EpicStatusType = typeof App03EpicStatus[keyof typeof App03EpicStatus];

export const getApp03EpicStatusDisplay = (status: string): string => {
    switch (status) {
        case App03EpicStatus.NotStarted:
            return "Not Started";
        case App03EpicStatus.InProgress:
            return "In Progress";
        case App03EpicStatus.Completed:
            return "Completed";
        case App03EpicStatus.Canceled:
            return "Canceled";
        default:
            return status; // fallback in case of unexpected value
    }
};

